import React, { useReducer } from 'react';
import CriticaContext from './criticaContext';
import CriticaReducer from './criticaReducer';

import { 
    CRITICAS_PROYECTO,
    AGREGAR_CRITICA,
    VALIDAR_CRITICA,
    ELIMINAR_CRITICA,
    CRITICA_ACTUAL,
    ACTUALIZAR_CRITICA,
    LIMPIAR_CRITICA,
    MOSTRAR_FORMULARIO
} from '../../types';

import clienteAxios from '../../config/axios';

const CriticaState = props => {
    const initialState = {
        criticasproyecto: [],
        errorcritica: false,
        criticaseleccionada: null,
        estadoformulario: false,
    }

    // Crear dispatch y state
    const [state, dispatch] = useReducer(CriticaReducer, initialState);

    // Crear las funciones

    // Obtener las criticas de un proyecto
    const obtenerCriticas = async proyecto => {


        try {
            const resultado = await clienteAxios.get('/api/criticas', { params: { proyecto }});
            console.log(resultado);
            dispatch({
                type: CRITICAS_PROYECTO,
                payload: resultado.data.criticas
            })
        } catch (error) {
            console.log(error);
        }
    }

    // Agregar una critica al proyecto seleccionado
    const agregarCritica = async critica => {
        console.log(critica);
        try {
            const resultado = await clienteAxios.post('/api/criticas', critica);
            console.log(resultado);
            dispatch({
                type: AGREGAR_CRITICA,
                payload: critica
            })
        } catch (error) {
            console.log(error);
        }
    }

    // Valida y muestra un error en caso de que sea necesario
    const validarCritica = () => {
        dispatch({
            type: VALIDAR_CRITICA
        })
    }

    // Eliminar critica por id
    const eliminarCritica = async (id, proyecto) => { 
        try {
            await clienteAxios.delete(`/api/criticas/${id}`, { params: { proyecto }});
            dispatch({
                type: ELIMINAR_CRITICA,
                payload: id
            })
        } catch (error) {
            console.log(error) 
        }
    }

    // Edita o modifica una critica
    const actualizarCritica = async critica => {

        try {
            const resultado = await clienteAxios.put(`/api/criticas/${critica._id}`, critica);
            
            dispatch({
                type: ACTUALIZAR_CRITICA,
                payload: resultado.data.critica
            })
        } catch (error) {
            console.log(error);
        }
    }

    // Extrae una critica para edición
    const guardarCriticaActual = critica => {
        dispatch({
            type: CRITICA_ACTUAL,
            payload: critica
        })
    }

    //mostrar o no el formulario
    const mostrarFormulario = (estado) => {
        dispatch({
            type: MOSTRAR_FORMULARIO,
            payload: estado
        })
    }

    // Elimina la criticaseleccionada
    const limpiarCritica = () => {
        dispatch({
            type: LIMPIAR_CRITICA
        })
    }

    return (
        <CriticaContext.Provider
            value={{
                criticasproyecto : state.criticasproyecto,
                errorcritica: state.errorcritica,
                criticaseleccionada: state.criticaseleccionada,
                estadoformulario: state.estadoformulario,
                obtenerCriticas,
                agregarCritica,
                validarCritica,
                eliminarCritica,
                guardarCriticaActual,
                actualizarCritica,
                limpiarCritica,
                mostrarFormulario
            }}
        >
            {props.children}
        </CriticaContext.Provider>
    )
}

export default CriticaState;